var map = {
	"./1K.jpg": "./src/assets/images/stockaudios/1K.jpg",
	"./45.jpg": "./src/assets/images/stockaudios/45.jpg",
	"./A Dance Under the Stars.jpg": "./src/assets/images/stockaudios/A Dance Under the Stars.jpg",
	"./A Distant Shore.jpg": "./src/assets/images/stockaudios/A Distant Shore.jpg",
	"./A Good Mood.jpg": "./src/assets/images/stockaudios/A Good Mood.jpg",
	"./A Look Out.jpg": "./src/assets/images/stockaudios/A Look Out.jpg",
	"./A Place Beyond Belief.jpg": "./src/assets/images/stockaudios/A Place Beyond Belief.jpg",
	"./A Safe Place.jpg": "./src/assets/images/stockaudios/A Safe Place.jpg",
	"./A Shot in the Dark.jpg": "./src/assets/images/stockaudios/A Shot in the Dark.jpg",
	"./A Thousand Eyes.jpg": "./src/assets/images/stockaudios/A Thousand Eyes.jpg",
	"./Ace of Spades.jpg": "./src/assets/images/stockaudios/Ace of Spades.jpg",
	"./Advice from a Caterpillar (Part 2).jpg": "./src/assets/images/stockaudios/Advice from a Caterpillar (Part 2).jpg",
	"./After the Movie (by Plaid) - Remix Version.jpg": "./src/assets/images/stockaudios/After the Movie (by Plaid) - Remix Version.jpg",
	"./Against Gravity.jpg": "./src/assets/images/stockaudios/Against Gravity.jpg",
	"./Ageless - Instrumental Version.jpg": "./src/assets/images/stockaudios/Ageless - Instrumental Version.jpg",
	"./Ageless.jpg": "./src/assets/images/stockaudios/Ageless.jpg",
	"./All Good Vibes.jpg": "./src/assets/images/stockaudios/All Good Vibes.jpg",
	"./All That I Want.jpg": "./src/assets/images/stockaudios/All That I Want.jpg",
	"./All That Matters.jpg": "./src/assets/images/stockaudios/All That Matters.jpg",
	"./All Things.jpg": "./src/assets/images/stockaudios/All Things.jpg",
	"./All This Love.jpg": "./src/assets/images/stockaudios/All This Love.jpg",
	"./Almanac.jpg": "./src/assets/images/stockaudios/Almanac.jpg",
	"./Always Enough.jpg": "./src/assets/images/stockaudios/Always Enough.jpg",
	"./Always Roaming.jpg": "./src/assets/images/stockaudios/Always Roaming.jpg",
	"./Ambitious Proletariat.jpg": "./src/assets/images/stockaudios/Ambitious Proletariat.jpg",
	"./American Hebrew - Instrumental Version.jpg": "./src/assets/images/stockaudios/American Hebrew - Instrumental Version.jpg",
	"./American Hope.jpg": "./src/assets/images/stockaudios/American Hope.jpg",
	"./Amsterdam.jpg": "./src/assets/images/stockaudios/Amsterdam.jpg",
	"./An Chuilfhionn - Strings Version.jpg": "./src/assets/images/stockaudios/An Chuilfhionn - Strings Version.jpg",
	"./Ancient Sailing.jpg": "./src/assets/images/stockaudios/Ancient Sailing.jpg",
	"./Angel Eyes.jpg": "./src/assets/images/stockaudios/Angel Eyes.jpg",
	"./Another Green World.jpg": "./src/assets/images/stockaudios/Another Green World.jpg",
	"./Approaching.jpg": "./src/assets/images/stockaudios/Approaching.jpg",
	"./Aquamarine.jpg": "./src/assets/images/stockaudios/Aquamarine.jpg",
	"./Aquarius.jpg": "./src/assets/images/stockaudios/Aquarius.jpg",
	"./Around Again Cover Art.jpg": "./src/assets/images/stockaudios/Around Again Cover Art.jpg",
	"./At Last.jpg": "./src/assets/images/stockaudios/At Last.jpg",
	"./Atlas.jpg": "./src/assets/images/stockaudios/Atlas.jpg",
	"./Autumn Wind.jpg": "./src/assets/images/stockaudios/Autumn Wind.jpg",
	"./Autumn in Paris.jpg": "./src/assets/images/stockaudios/Autumn in Paris.jpg",
	"./Awake (East Africa).jpg": "./src/assets/images/stockaudios/Awake (East Africa).jpg",
	"./Awaken.jpg": "./src/assets/images/stockaudios/Awaken.jpg",
	"./Awamamba.jpg": "./src/assets/images/stockaudios/Awamamba.jpg",
	"./Away We Go Cover Art.jpg": "./src/assets/images/stockaudios/Away We Go Cover Art.jpg",
	"./Awoke.jpg": "./src/assets/images/stockaudios/Awoke.jpg",
	"./Back to 95 - ft Lance Conrad.jpg": "./src/assets/images/stockaudios/Back to 95 - ft Lance Conrad.jpg",
	"./Back to Bach.jpg": "./src/assets/images/stockaudios/Back to Bach.jpg",
	"./Ballerina.jpg": "./src/assets/images/stockaudios/Ballerina.jpg",
	"./Ballroom.jpg": "./src/assets/images/stockaudios/Ballroom.jpg",
	"./Beach Party.jpg": "./src/assets/images/stockaudios/Beach Party.jpg",
	"./Beautiful Day for the Road.jpg": "./src/assets/images/stockaudios/Beautiful Day for the Road.jpg",
	"./Befun - Instrumental Version.jpg": "./src/assets/images/stockaudios/Befun - Instrumental Version.jpg",
	"./Befun.jpg": "./src/assets/images/stockaudios/Befun.jpg",
	"./Believe the Hype.jpg": "./src/assets/images/stockaudios/Believe the Hype.jpg",
	"./Believer.jpg": "./src/assets/images/stockaudios/Believer.jpg",
	"./Belonging.jpg": "./src/assets/images/stockaudios/Belonging.jpg",
	"./Best Friends.jpg": "./src/assets/images/stockaudios/Best Friends.jpg",
	"./Best Part of Me.jpg": "./src/assets/images/stockaudios/Best Part of Me.jpg",
	"./Better Now.jpg": "./src/assets/images/stockaudios/Better Now.jpg",
	"./Betula Lenta.jpg": "./src/assets/images/stockaudios/Betula Lenta.jpg",
	"./Beyond a Dream.jpg": "./src/assets/images/stockaudios/Beyond a Dream.jpg",
	"./Beyond the Stories.jpg": "./src/assets/images/stockaudios/Beyond the Stories.jpg",
	"./Big Sky.jpg": "./src/assets/images/stockaudios/Big Sky.jpg",
	"./Big Time.jpg": "./src/assets/images/stockaudios/Big Time.jpg",
	"./Big White Ship.jpg": "./src/assets/images/stockaudios/Big White Ship.jpg",
	"./Birds and Daisies.jpg": "./src/assets/images/stockaudios/Birds and Daisies.jpg",
	"./Blanket.jpg": "./src/assets/images/stockaudios/Blanket.jpg",
	"./Blessed Midwest - Instrumental Version.jpg": "./src/assets/images/stockaudios/Blessed Midwest - Instrumental Version.jpg",
	"./Blessed Midwest.jpg": "./src/assets/images/stockaudios/Blessed Midwest.jpg",
	"./Blind - Naked.jpg": "./src/assets/images/stockaudios/Blind - Naked.jpg",
	"./Blondie.jpg": "./src/assets/images/stockaudios/Blondie.jpg",
	"./Blue Race.jpg": "./src/assets/images/stockaudios/Blue Race.jpg",
	"./Bluerise.jpg": "./src/assets/images/stockaudios/Bluerise.jpg",
	"./Body on Fire (with Maya Isac).jpg": "./src/assets/images/stockaudios/Body on Fire (with Maya Isac).jpg",
	"./Bold.jpg": "./src/assets/images/stockaudios/Bold.jpg",
	"./Born Again - Instrumental Version.jpg": "./src/assets/images/stockaudios/Born Again - Instrumental Version.jpg",
	"./Born Again.jpg": "./src/assets/images/stockaudios/Born Again.jpg",
	"./Born to Become.jpg": "./src/assets/images/stockaudios/Born to Become.jpg",
	"./Boundary.jpg": "./src/assets/images/stockaudios/Boundary.jpg",
	"./Breaking Point.jpg": "./src/assets/images/stockaudios/Breaking Point.jpg",
	"./Breathe.jpg": "./src/assets/images/stockaudios/Breathe.jpg",
	"./Brief Moment.jpg": "./src/assets/images/stockaudios/Brief Moment.jpg",
	"./Brighter Days.jpg": "./src/assets/images/stockaudios/Brighter Days.jpg",
	"./Brightness.jpg": "./src/assets/images/stockaudios/Brightness.jpg",
	"./Bring to Light.jpg": "./src/assets/images/stockaudios/Bring to Light.jpg",
	"./Broadway.jpg": "./src/assets/images/stockaudios/Broadway.jpg",
	"./Brotherhood.jpg": "./src/assets/images/stockaudios/Brotherhood.jpg",
	"./Bullet from a Gun.jpg": "./src/assets/images/stockaudios/Bullet from a Gun.jpg",
	"./Burdens.jpg": "./src/assets/images/stockaudios/Burdens.jpg",
	"./Cabana.jpg": "./src/assets/images/stockaudios/Cabana.jpg",
	"./Calgary.jpg": "./src/assets/images/stockaudios/Calgary.jpg",
	"./Call On Me.jpg": "./src/assets/images/stockaudios/Call On Me.jpg",
	"./Camping.jpg": "./src/assets/images/stockaudios/Camping.jpg",
	"./Can You Feel the Heaviness, She Said.jpg": "./src/assets/images/stockaudios/Can You Feel the Heaviness, She Said.jpg",
	"./Canoe - No Lead Vocals.jpg": "./src/assets/images/stockaudios/Canoe - No Lead Vocals.jpg",
	"./Cant Help It.jpg": "./src/assets/images/stockaudios/Cant Help It.jpg",
	"./Canyons Cover Art.jpg": "./src/assets/images/stockaudios/Canyons Cover Art.jpg",
	"./Carousel.jpg": "./src/assets/images/stockaudios/Carousel.jpg",
	"./Cave Dweller.jpg": "./src/assets/images/stockaudios/Cave Dweller.jpg",
	"./Century City.jpg": "./src/assets/images/stockaudios/Century City.jpg",
	"./Challenge Accepted.jpg": "./src/assets/images/stockaudios/Challenge Accepted.jpg",
	"./Champa.jpg": "./src/assets/images/stockaudios/Champa.jpg",
	"./Cheesecake - No Backing Vocals.jpg": "./src/assets/images/stockaudios/Cheesecake - No Backing Vocals.jpg",
	"./Cherry Blossom.jpg": "./src/assets/images/stockaudios/Cherry Blossom.jpg",
	"./Chikyuu.jpg": "./src/assets/images/stockaudios/Chikyuu.jpg",
	"./Christmas Around the World.jpg": "./src/assets/images/stockaudios/Christmas Around the World.jpg",
	"./Christmas Joy.jpg": "./src/assets/images/stockaudios/Christmas Joy.jpg",
	"./Chroma.jpg": "./src/assets/images/stockaudios/Chroma.jpg",
	"./Circle.jpg": "./src/assets/images/stockaudios/Circle.jpg",
	"./Circus Clown.jpg": "./src/assets/images/stockaudios/Circus Clown.jpg",
	"./City Buds.jpg": "./src/assets/images/stockaudios/City Buds.jpg",
	"./Clockwork.jpg": "./src/assets/images/stockaudios/Clockwork.jpg",
	"./Cloud Line.jpg": "./src/assets/images/stockaudios/Cloud Line.jpg",
	"./Coal Mine Rhythm.jpg": "./src/assets/images/stockaudios/Coal Mine Rhythm.jpg",
	"./Coconuts.jpg": "./src/assets/images/stockaudios/Coconuts.jpg",
	"./Cold.jpg": "./src/assets/images/stockaudios/Cold.jpg",
	"./Colonization of Mars.jpg": "./src/assets/images/stockaudios/Colonization of Mars.jpg",
	"./Come Back Home.jpg": "./src/assets/images/stockaudios/Come Back Home.jpg",
	"./Coming for You.jpg": "./src/assets/images/stockaudios/Coming for You.jpg",
	"./Coming in Out.jpg": "./src/assets/images/stockaudios/Coming in Out.jpg",
	"./Continent.jpg": "./src/assets/images/stockaudios/Continent.jpg",
	"./Copper Queen.jpg": "./src/assets/images/stockaudios/Copper Queen.jpg",
	"./Corner Head.jpg": "./src/assets/images/stockaudios/Corner Head.jpg",
	"./Countdown Cover Art.jpg": "./src/assets/images/stockaudios/Countdown Cover Art.jpg",
	"./Dark Fantasy.jpg": "./src/assets/images/stockaudios/Dark Fantasy.jpg",
	"./Dark Tension.jpg": "./src/assets/images/stockaudios/Dark Tension.jpg",
	"./Days Pass.jpg": "./src/assets/images/stockaudios/Days Pass.jpg",
	"./Dead Wait.jpg": "./src/assets/images/stockaudios/Dead Wait.jpg",
	"./Deep Horizon.jpg": "./src/assets/images/stockaudios/Deep Horizon.jpg",
	"./Deep.jpg": "./src/assets/images/stockaudios/Deep.jpg",
	"./Delusional.jpg": "./src/assets/images/stockaudios/Delusional.jpg",
	"./Diamond in the Rough.jpg": "./src/assets/images/stockaudios/Diamond in the Rough.jpg",
	"./Diary of Ideas.jpg": "./src/assets/images/stockaudios/Diary of Ideas.jpg",
	"./Discovery.jpg": "./src/assets/images/stockaudios/Discovery.jpg",
	"./Dive.jpg": "./src/assets/images/stockaudios/Dive.jpg",
	"./Do Your Thing - Instrumental Version.jpg": "./src/assets/images/stockaudios/Do Your Thing - Instrumental Version.jpg",
	"./Do.jpg": "./src/assets/images/stockaudios/Do.jpg",
	"./Doing the Right Thing.jpg": "./src/assets/images/stockaudios/Doing the Right Thing.jpg",
	"./Don't Stand a Chance.jpg": "./src/assets/images/stockaudios/Don't Stand a Chance.jpg",
	"./Don't Wake Me Up.jpg": "./src/assets/images/stockaudios/Don't Wake Me Up.jpg",
	"./Dorrigo.jpg": "./src/assets/images/stockaudios/Dorrigo.jpg",
	"./Drawn Home.jpg": "./src/assets/images/stockaudios/Drawn Home.jpg",
	"./Dream.jpg": "./src/assets/images/stockaudios/Dream.jpg",
	"./Drinks on Me.jpg": "./src/assets/images/stockaudios/Drinks on Me.jpg",
	"./Drop the Roof.jpg": "./src/assets/images/stockaudios/Drop the Roof.jpg",
	"./Ear Pollution.jpg": "./src/assets/images/stockaudios/Ear Pollution.jpg",
	"./Early Dawn.jpg": "./src/assets/images/stockaudios/Early Dawn.jpg",
	"./Early Morning.jpg": "./src/assets/images/stockaudios/Early Morning.jpg",
	"./Eclipse.jpg": "./src/assets/images/stockaudios/Eclipse.jpg",
	"./Edit Beats.jpg": "./src/assets/images/stockaudios/Edit Beats.jpg",
	"./El Mayor.jpg": "./src/assets/images/stockaudios/El Mayor.jpg",
	"./El Monte.jpg": "./src/assets/images/stockaudios/El Monte.jpg",
	"./Elements.jpg": "./src/assets/images/stockaudios/Elements.jpg",
	"./Elevating Burst.jpg": "./src/assets/images/stockaudios/Elevating Burst.jpg",
	"./Eminence Landscapes.jpg": "./src/assets/images/stockaudios/Eminence Landscapes.jpg",
	"./Empty Beaches.jpg": "./src/assets/images/stockaudios/Empty Beaches.jpg",
	"./Empty Houses.jpg": "./src/assets/images/stockaudios/Empty Houses.jpg",
	"./Empyrean.jpg": "./src/assets/images/stockaudios/Empyrean.jpg",
	"./End Time Delusion.jpg": "./src/assets/images/stockaudios/End Time Delusion.jpg",
	"./Endless Hope.jpg": "./src/assets/images/stockaudios/Endless Hope.jpg",
	"./Enjoy the Ride Cover Art.jpg": "./src/assets/images/stockaudios/Enjoy the Ride Cover Art.jpg",
	"./Epicness.jpg": "./src/assets/images/stockaudios/Epicness.jpg",
	"./Escape.jpg": "./src/assets/images/stockaudios/Escape.jpg",
	"./Explore Together.jpg": "./src/assets/images/stockaudios/Explore Together.jpg",
	"./Express.jpg": "./src/assets/images/stockaudios/Express.jpg",
	"./F2203828-45E9-4465-B0AD-FC7EF15895B2.jpeg": "./src/assets/images/stockaudios/F2203828-45E9-4465-B0AD-FC7EF15895B2.jpeg",
	"./FLY.jpg": "./src/assets/images/stockaudios/FLY.jpg",
	"./Fake.jpg": "./src/assets/images/stockaudios/Fake.jpg",
	"./Falling Forward.jpg": "./src/assets/images/stockaudios/Falling Forward.jpg",
	"./Fantastico.jpg": "./src/assets/images/stockaudios/Fantastico.jpg",
	"./Farewell.jpg": "./src/assets/images/stockaudios/Farewell.jpg",
	"./Faster Than My Dreams.jpg": "./src/assets/images/stockaudios/Faster Than My Dreams.jpg",
	"./Fiddler.jpg": "./src/assets/images/stockaudios/Fiddler.jpg",
	"./First and Last.jpg": "./src/assets/images/stockaudios/First and Last.jpg",
	"./Five Spiral.jpg": "./src/assets/images/stockaudios/Five Spiral.jpg",
	"./Flight.jpg": "./src/assets/images/stockaudios/Flight.jpg",
	"./Floating Point.jpg": "./src/assets/images/stockaudios/Floating Point.jpg",
	"./Flow Free.jpg": "./src/assets/images/stockaudios/Flow Free.jpg",
	"./Flowing.jpg": "./src/assets/images/stockaudios/Flowing.jpg",
	"./Folkarama.jpg": "./src/assets/images/stockaudios/Folkarama.jpg",
	"./Following You.jpg": "./src/assets/images/stockaudios/Following You.jpg",
	"./For a Lifetime.jpg": "./src/assets/images/stockaudios/For a Lifetime.jpg",
	"./For the Brave Who Silently Slip from the Earth.jpg": "./src/assets/images/stockaudios/For the Brave Who Silently Slip from the Earth.jpg",
	"./Forever - Instrumental Version.jpg": "./src/assets/images/stockaudios/Forever - Instrumental Version.jpg",
	"./Forever Girl.jpg": "./src/assets/images/stockaudios/Forever Girl.jpg",
	"./Forget the Past.jpg": "./src/assets/images/stockaudios/Forget the Past.jpg",
	"./Forgotten Glory.jpg": "./src/assets/images/stockaudios/Forgotten Glory.jpg",
	"./Fortress.jpg": "./src/assets/images/stockaudios/Fortress.jpg",
	"./Free Radicals.jpg": "./src/assets/images/stockaudios/Free Radicals.jpg",
	"./Freedom Mile - Instrumental Version Cover Art.jpg": "./src/assets/images/stockaudios/Freedom Mile - Instrumental Version Cover Art.jpg",
	"./Freedom.jpg": "./src/assets/images/stockaudios/Freedom.jpg",
	"./Freehand.jpg": "./src/assets/images/stockaudios/Freehand.jpg",
	"./Freerolling.jpg": "./src/assets/images/stockaudios/Freerolling.jpg",
	"./Freeway.jpg": "./src/assets/images/stockaudios/Freeway.jpg",
	"./Full of Bricks.jpg": "./src/assets/images/stockaudios/Full of Bricks.jpg",
	"./Futuristic Cliche.jpg": "./src/assets/images/stockaudios/Futuristic Cliche.jpg",
	"./Get Gone.jpg": "./src/assets/images/stockaudios/Get Gone.jpg",
	"./Ghost Mantis.jpg": "./src/assets/images/stockaudios/Ghost Mantis.jpg",
	"./Give It Up, Don't Give It Away.jpg": "./src/assets/images/stockaudios/Give It Up, Don't Give It Away.jpg",
	"./Give It Up.jpg": "./src/assets/images/stockaudios/Give It Up.jpg",
	"./Glow.jpg": "./src/assets/images/stockaudios/Glow.jpg",
	"./Go.jpg": "./src/assets/images/stockaudios/Go.jpg",
	"./Golden Days.jpg": "./src/assets/images/stockaudios/Golden Days.jpg",
	"./Golden Sunrise.jpg": "./src/assets/images/stockaudios/Golden Sunrise.jpg",
	"./Got It.jpg": "./src/assets/images/stockaudios/Got It.jpg",
	"./Gotta Love.jpg": "./src/assets/images/stockaudios/Gotta Love.jpg",
	"./Grace - Instrumental Version.jpg": "./src/assets/images/stockaudios/Grace - Instrumental Version.jpg",
	"./Grace.jpg": "./src/assets/images/stockaudios/Grace.jpg",
	"./Gravity - Short Version.jpg": "./src/assets/images/stockaudios/Gravity - Short Version.jpg",
	"./Green Valley.jpg": "./src/assets/images/stockaudios/Green Valley.jpg",
	"./Grounding Mcbeth.jpg": "./src/assets/images/stockaudios/Grounding Mcbeth.jpg",
	"./Hafla.jpg": "./src/assets/images/stockaudios/Hafla.jpg",
	"./Halation.jpg": "./src/assets/images/stockaudios/Halation.jpg",
	"./Hammer and Felt.jpg": "./src/assets/images/stockaudios/Hammer and Felt.jpg",
	"./Hanakotoba.jpg": "./src/assets/images/stockaudios/Hanakotoba.jpg",
	"./Happiness Can Make You Cry - Instrumental Version.jpg": "./src/assets/images/stockaudios/Happiness Can Make You Cry - Instrumental Version.jpg",
	"./Hard to Love - Instrumental Version.jpg": "./src/assets/images/stockaudios/Hard to Love - Instrumental Version.jpg",
	"./Having a Good Day.jpg": "./src/assets/images/stockaudios/Having a Good Day.jpg",
	"./Healer Might.jpg": "./src/assets/images/stockaudios/Healer Might.jpg",
	"./Heartbreak Please.jpg": "./src/assets/images/stockaudios/Heartbreak Please.jpg",
	"./Heimweh.jpg": "./src/assets/images/stockaudios/Heimweh.jpg",
	"./Helios.jpg": "./src/assets/images/stockaudios/Helios.jpg",
	"./Hell Yeah - Instrumental Version.jpg": "./src/assets/images/stockaudios/Hell Yeah - Instrumental Version.jpg",
	"./Help Me Stand.jpg": "./src/assets/images/stockaudios/Help Me Stand.jpg",
	"./Her World.jpg": "./src/assets/images/stockaudios/Her World.jpg",
	"./Hera.jpg": "./src/assets/images/stockaudios/Hera.jpg",
	"./Here.jpg": "./src/assets/images/stockaudios/Here.jpg",
	"./High Flight.jpg": "./src/assets/images/stockaudios/High Flight.jpg",
	"./High Stepping Jessy.jpg": "./src/assets/images/stockaudios/High Stepping Jessy.jpg",
	"./Hit the Ground Running.jpg": "./src/assets/images/stockaudios/Hit the Ground Running.jpg",
	"./Hiving.jpg": "./src/assets/images/stockaudios/Hiving.jpg",
	"./Hold Back the Sun.jpg": "./src/assets/images/stockaudios/Hold Back the Sun.jpg",
	"./Hold Me Down - Instrumental Version.jpg": "./src/assets/images/stockaudios/Hold Me Down - Instrumental Version.jpg",
	"./Home.jpg": "./src/assets/images/stockaudios/Home.jpg",
	"./Homecoming - Instrumental Version Cover Art.jpg": "./src/assets/images/stockaudios/Homecoming - Instrumental Version Cover Art.jpg",
	"./Honey (ft West Am).jpg": "./src/assets/images/stockaudios/Honey (ft West Am).jpg",
	"./Hope.jpg": "./src/assets/images/stockaudios/Hope.jpg",
	"./Howling at the Moon - Instrumental Version.jpg": "./src/assets/images/stockaudios/Howling at the Moon - Instrumental Version.jpg",
	"./Howling at the Moon - No Lead Vocals.jpg": "./src/assets/images/stockaudios/Howling at the Moon - No Lead Vocals.jpg",
	"./Human.jpg": "./src/assets/images/stockaudios/Human.jpg",
	"./Humdrum Life (ft Inbar Livne).jpg": "./src/assets/images/stockaudios/Humdrum Life (ft Inbar Livne).jpg",
	"./Hustle Harder.jpg": "./src/assets/images/stockaudios/Hustle Harder.jpg",
	"./I Choose You.jpg": "./src/assets/images/stockaudios/I Choose You.jpg",
	"./I Do.jpg": "./src/assets/images/stockaudios/I Do.jpg",
	"./I Don't Know What's Gonna Kill Me.jpg": "./src/assets/images/stockaudios/I Don't Know What's Gonna Kill Me.jpg",
	"./I Get Up.jpg": "./src/assets/images/stockaudios/I Get Up.jpg",
	"./I Promise.jpg": "./src/assets/images/stockaudios/I Promise.jpg",
	"./I Remember.jpg": "./src/assets/images/stockaudios/I Remember.jpg",
	"./I'll Be There.jpg": "./src/assets/images/stockaudios/I'll Be There.jpg",
	"./I'm Falling.jpg": "./src/assets/images/stockaudios/I'm Falling.jpg",
	"./I'm Not Ready - Instrumental Version.jpg": "./src/assets/images/stockaudios/I'm Not Ready - Instrumental Version.jpg",
	"./ID.jpg": "./src/assets/images/stockaudios/ID.jpg",
	"./IOU.jpg": "./src/assets/images/stockaudios/IOU.jpg",
	"./Icicles.jpg": "./src/assets/images/stockaudios/Icicles.jpg",
	"./If I Were King.jpg": "./src/assets/images/stockaudios/If I Were King.jpg",
	"./If You Wanna.jpg": "./src/assets/images/stockaudios/If You Wanna.jpg",
	"./Im a Boss.jpg": "./src/assets/images/stockaudios/Im a Boss.jpg",
	"./Imagine the Adventure.jpg": "./src/assets/images/stockaudios/Imagine the Adventure.jpg",
	"./Imagine.jpg": "./src/assets/images/stockaudios/Imagine.jpg",
	"./Impacts.jpg": "./src/assets/images/stockaudios/Impacts.jpg",
	"./Impavid.jpg": "./src/assets/images/stockaudios/Impavid.jpg",
	"./In My Zone.jpg": "./src/assets/images/stockaudios/In My Zone.jpg",
	"./In Pulse Cover Art.jpg": "./src/assets/images/stockaudios/In Pulse Cover Art.jpg",
	"./In a Dream - Instrumental Version.jpg": "./src/assets/images/stockaudios/In a Dream - Instrumental Version.jpg",
	"./In a Dream.jpg": "./src/assets/images/stockaudios/In a Dream.jpg",
	"./Incandescent with Passion.jpg": "./src/assets/images/stockaudios/Incandescent with Passion.jpg",
	"./Inkling.jpg": "./src/assets/images/stockaudios/Inkling.jpg",
	"./Innovate.jpg": "./src/assets/images/stockaudios/Innovate.jpg",
	"./Into the Battle.jpg": "./src/assets/images/stockaudios/Into the Battle.jpg",
	"./Intro.jpg": "./src/assets/images/stockaudios/Intro.jpg",
	"./Invincible.jpg": "./src/assets/images/stockaudios/Invincible.jpg",
	"./Iramasa.jpg": "./src/assets/images/stockaudios/Iramasa.jpg",
	"./It'll Be Alright.jpg": "./src/assets/images/stockaudios/It'll Be Alright.jpg",
	"./It’s Not Over Yet.jpg": "./src/assets/images/stockaudios/It’s Not Over Yet.jpg",
	"./Jaan.jpg": "./src/assets/images/stockaudios/Jaan.jpg",
	"./Jack Son Samba.jpg": "./src/assets/images/stockaudios/Jack Son Samba.jpg",
	"./Jell-O - Instrumental Version.jpg": "./src/assets/images/stockaudios/Jell-O - Instrumental Version.jpg",
	"./Jell-O.jpg": "./src/assets/images/stockaudios/Jell-O.jpg",
	"./Jesse James Style.jpg": "./src/assets/images/stockaudios/Jesse James Style.jpg",
	"./John and Barry.jpg": "./src/assets/images/stockaudios/John and Barry.jpg",
	"./Johnny Vespa.jpg": "./src/assets/images/stockaudios/Johnny Vespa.jpg",
	"./Joking Together.jpg": "./src/assets/images/stockaudios/Joking Together.jpg",
	"./Journey of the Fearless.jpg": "./src/assets/images/stockaudios/Journey of the Fearless.jpg",
	"./Just Jump.jpg": "./src/assets/images/stockaudios/Just Jump.jpg",
	"./Just So Happens.jpg": "./src/assets/images/stockaudios/Just So Happens.jpg",
	"./Kaleidoscope.jpg": "./src/assets/images/stockaudios/Kaleidoscope.jpg",
	"./Kalimbo.jpg": "./src/assets/images/stockaudios/Kalimbo.jpg",
	"./Keep an Eye.jpg": "./src/assets/images/stockaudios/Keep an Eye.jpg",
	"./Kids - Instrumental Version.jpg": "./src/assets/images/stockaudios/Kids - Instrumental Version.jpg",
	"./King of Mandol.jpg": "./src/assets/images/stockaudios/King of Mandol.jpg",
	"./Kingdom Come.jpg": "./src/assets/images/stockaudios/Kingdom Come.jpg",
	"./Kryptonite.jpg": "./src/assets/images/stockaudios/Kryptonite.jpg",
	"./La Alegria del Valle.jpg": "./src/assets/images/stockaudios/La Alegria del Valle.jpg",
	"./La La La (Love You Like).jpg": "./src/assets/images/stockaudios/La La La (Love You Like).jpg",
	"./La Luna e la Fisarmonica - Instrumental Version.jpg": "./src/assets/images/stockaudios/La Luna e la Fisarmonica - Instrumental Version.jpg",
	"./La promesa.jpg": "./src/assets/images/stockaudios/La promesa.jpg",
	"./Lakeview.jpg": "./src/assets/images/stockaudios/Lakeview.jpg",
	"./Last Countdown to the End.jpg": "./src/assets/images/stockaudios/Last Countdown to the End.jpg",
	"./Leaving Earth.jpg": "./src/assets/images/stockaudios/Leaving Earth.jpg",
	"./Lemonade.jpg": "./src/assets/images/stockaudios/Lemonade.jpg",
	"./Let Me In - Instrumental Version.jpg": "./src/assets/images/stockaudios/Let Me In - Instrumental Version.jpg",
	"./Lever de la Lune.jpg": "./src/assets/images/stockaudios/Lever de la Lune.jpg",
	"./Lie in the Sun - No Lead Vocals.jpg": "./src/assets/images/stockaudios/Lie in the Sun - No Lead Vocals.jpg",
	"./Lie in the Sun.jpg": "./src/assets/images/stockaudios/Lie in the Sun.jpg",
	"./Life Is Worth Living - Instrumental Version.jpg": "./src/assets/images/stockaudios/Life Is Worth Living - Instrumental Version.jpg",
	"./Lifeline.jpg": "./src/assets/images/stockaudios/Lifeline.jpg",
	"./Like a Feather.jpg": "./src/assets/images/stockaudios/Like a Feather.jpg",
	"./Like the Morning.jpg": "./src/assets/images/stockaudios/Like the Morning.jpg",
	"./Limitless.jpg": "./src/assets/images/stockaudios/Limitless.jpg",
	"./Lionheart.jpg": "./src/assets/images/stockaudios/Lionheart.jpg",
	"./Lonely Plates.jpg": "./src/assets/images/stockaudios/Lonely Plates.jpg",
	"./Love Is Where You Are.jpg": "./src/assets/images/stockaudios/Love Is Where You Are.jpg",
	"./Love Life.jpg": "./src/assets/images/stockaudios/Love Life.jpg",
	"./Love of Mine.jpg": "./src/assets/images/stockaudios/Love of Mine.jpg",
	"./Love.jpg": "./src/assets/images/stockaudios/Love.jpg",
	"./Lover Please Stay (ft Ben Sharkey).jpg": "./src/assets/images/stockaudios/Lover Please Stay (ft Ben Sharkey).jpg",
	"./Lucky 7.jpg": "./src/assets/images/stockaudios/Lucky 7.jpg",
	"./Lucky Me.jpg": "./src/assets/images/stockaudios/Lucky Me.jpg",
	"./Lucky Number.jpg": "./src/assets/images/stockaudios/Lucky Number.jpg",
	"./Maasai.jpg": "./src/assets/images/stockaudios/Maasai.jpg",
	"./Machine Heart.jpg": "./src/assets/images/stockaudios/Machine Heart.jpg",
	"./Magic.jpg": "./src/assets/images/stockaudios/Magic.jpg",
	"./Make It Rock.jpg": "./src/assets/images/stockaudios/Make It Rock.jpg",
	"./Make My Love Your Home - Instrumental Version.jpg": "./src/assets/images/stockaudios/Make My Love Your Home - Instrumental Version.jpg",
	"./Make My Love Your Home.jpg": "./src/assets/images/stockaudios/Make My Love Your Home.jpg",
	"./Make You Mine.jpg": "./src/assets/images/stockaudios/Make You Mine.jpg",
	"./Mare Imbrrium.jpg": "./src/assets/images/stockaudios/Mare Imbrrium.jpg",
	"./Midnight Hour - Instrumental Version.jpg": "./src/assets/images/stockaudios/Midnight Hour - Instrumental Version.jpg",
	"./Midnight Hour.jpg": "./src/assets/images/stockaudios/Midnight Hour.jpg",
	"./Millennials.jpg": "./src/assets/images/stockaudios/Millennials.jpg",
	"./Mindplay.jpg": "./src/assets/images/stockaudios/Mindplay.jpg",
	"./Miss Lindy.jpg": "./src/assets/images/stockaudios/Miss Lindy.jpg",
	"./Missing You.jpg": "./src/assets/images/stockaudios/Missing You.jpg",
	"./Mold Breakers - Instrumental Version.jpg": "./src/assets/images/stockaudios/Mold Breakers - Instrumental Version.jpg",
	"./Moments in Time.jpg": "./src/assets/images/stockaudios/Moments in Time.jpg",
	"./Momentum.jpg": "./src/assets/images/stockaudios/Momentum.jpg",
	"./Moon Waltz (2nd Movement) - Piano Version.jpg": "./src/assets/images/stockaudios/Moon Waltz (2nd Movement) - Piano Version.jpg",
	"./Moonchild.jpg": "./src/assets/images/stockaudios/Moonchild.jpg",
	"./Morning Rise.jpg": "./src/assets/images/stockaudios/Morning Rise.jpg",
	"./Motion.jpg": "./src/assets/images/stockaudios/Motion.jpg",
	"./MouthBeat Grooves.jpg": "./src/assets/images/stockaudios/MouthBeat Grooves.jpg",
	"./Music for the Soul - Instrumental Version.jpg": "./src/assets/images/stockaudios/Music for the Soul - Instrumental Version.jpg",
	"./Music for the Soul.jpg": "./src/assets/images/stockaudios/Music for the Soul.jpg",
	"./Music.jpg": "./src/assets/images/stockaudios/Music.jpg",
	"./My Country.jpg": "./src/assets/images/stockaudios/My Country.jpg",
	"./My One Safe Haven.jpg": "./src/assets/images/stockaudios/My One Safe Haven.jpg",
	"./My Rhapsody Sounds.jpg": "./src/assets/images/stockaudios/My Rhapsody Sounds.jpg",
	"./My Way - Remix.jpg": "./src/assets/images/stockaudios/My Way - Remix.jpg",
	"./Mythologica.jpg": "./src/assets/images/stockaudios/Mythologica.jpg",
	"./Naked Memories.jpg": "./src/assets/images/stockaudios/Naked Memories.jpg",
	"./Narcissus.jpg": "./src/assets/images/stockaudios/Narcissus.jpg",
	"./Nebulae.jpg": "./src/assets/images/stockaudios/Nebulae.jpg",
	"./Nesting.jpg": "./src/assets/images/stockaudios/Nesting.jpg",
	"./Never Back.jpg": "./src/assets/images/stockaudios/Never Back.jpg",
	"./Never Die.jpg": "./src/assets/images/stockaudios/Never Die.jpg",
	"./Never Looking Back - Instrumental Version.jpg": "./src/assets/images/stockaudios/Never Looking Back - Instrumental Version.jpg",
	"./New City.jpg": "./src/assets/images/stockaudios/New City.jpg",
	"./New Land.jpg": "./src/assets/images/stockaudios/New Land.jpg",
	"./Night Out.jpg": "./src/assets/images/stockaudios/Night Out.jpg",
	"./Night Rider.jpg": "./src/assets/images/stockaudios/Night Rider.jpg",
	"./Nina and the Waves.jpg": "./src/assets/images/stockaudios/Nina and the Waves.jpg",
	"./No Lie - Instrumental Version.jpg": "./src/assets/images/stockaudios/No Lie - Instrumental Version.jpg",
	"./No Limit.jpg": "./src/assets/images/stockaudios/No Limit.jpg",
	"./No Matter How Hard We Try (ft Ben Goldstein).jpg": "./src/assets/images/stockaudios/No Matter How Hard We Try (ft Ben Goldstein).jpg",
	"./No Words Required (ft Chris Swartwood).jpg": "./src/assets/images/stockaudios/No Words Required (ft Chris Swartwood).jpg",
	"./Nosebleed.jpg": "./src/assets/images/stockaudios/Nosebleed.jpg",
	"./Not Everything Not Yet.jpg": "./src/assets/images/stockaudios/Not Everything Not Yet.jpg",
	"./Now They Know.jpg": "./src/assets/images/stockaudios/Now They Know.jpg",
	"./Nowadays.jpg": "./src/assets/images/stockaudios/Nowadays.jpg",
	"./Nu Kinda Funk.jpg": "./src/assets/images/stockaudios/Nu Kinda Funk.jpg",
	"./Oasis.jpg": "./src/assets/images/stockaudios/Oasis.jpg",
	"./Ometepe Patterns.jpg": "./src/assets/images/stockaudios/Ometepe Patterns.jpg",
	"./On My Werk.jpg": "./src/assets/images/stockaudios/On My Werk.jpg",
	"./One Love.jpg": "./src/assets/images/stockaudios/One Love.jpg",
	"./One More Time.jpg": "./src/assets/images/stockaudios/One More Time.jpg",
	"./One of the Boys - No Lead Vocals.jpg": "./src/assets/images/stockaudios/One of the Boys - No Lead Vocals.jpg",
	"./One.jpg": "./src/assets/images/stockaudios/One.jpg",
	"./Opening Presents.jpg": "./src/assets/images/stockaudios/Opening Presents.jpg",
	"./Our Victory.jpg": "./src/assets/images/stockaudios/Our Victory.jpg",
	"./Over and Over.jpg": "./src/assets/images/stockaudios/Over and Over.jpg",
	"./Overdrive.jpg": "./src/assets/images/stockaudios/Overdrive.jpg",
	"./Panda Music.jpg": "./src/assets/images/stockaudios/Panda Music.jpg",
	"./Paper Planes.jpg": "./src/assets/images/stockaudios/Paper Planes.jpg",
	"./Papyrus.jpg": "./src/assets/images/stockaudios/Papyrus.jpg",
	"./Parody - Instrumental Version.jpg": "./src/assets/images/stockaudios/Parody - Instrumental Version.jpg",
	"./Party Up.jpg": "./src/assets/images/stockaudios/Party Up.jpg",
	"./Pensando en ti.jpg": "./src/assets/images/stockaudios/Pensando en ti.jpg",
	"./Pivotal.jpg": "./src/assets/images/stockaudios/Pivotal.jpg",
	"./Pixelate.jpg": "./src/assets/images/stockaudios/Pixelate.jpg",
	"./Planet Legacy.jpg": "./src/assets/images/stockaudios/Planet Legacy.jpg",
	"./Play Up.jpg": "./src/assets/images/stockaudios/Play Up.jpg",
	"./Play.jpg": "./src/assets/images/stockaudios/Play.jpg",
	"./Possible Light.jpg": "./src/assets/images/stockaudios/Possible Light.jpg",
	"./Present Moment 1 - Alternative Version.jpg": "./src/assets/images/stockaudios/Present Moment 1 - Alternative Version.jpg",
	"./Present Moment 2 - Alternative Version.jpg": "./src/assets/images/stockaudios/Present Moment 2 - Alternative Version.jpg",
	"./Promised.jpg": "./src/assets/images/stockaudios/Promised.jpg",
	"./Psycho.jpg": "./src/assets/images/stockaudios/Psycho.jpg",
	"./Puddles II.jpg": "./src/assets/images/stockaudios/Puddles II.jpg",
	"./Puddles.jpg": "./src/assets/images/stockaudios/Puddles.jpg",
	"./Purple.jpg": "./src/assets/images/stockaudios/Purple.jpg",
	"./Rainbows.jpg": "./src/assets/images/stockaudios/Rainbows.jpg",
	"./Rays.jpg": "./src/assets/images/stockaudios/Rays.jpg",
	"./Real Life.jpg": "./src/assets/images/stockaudios/Real Life.jpg",
	"./Real Wings.jpg": "./src/assets/images/stockaudios/Real Wings.jpg",
	"./Recuerdos Mios.jpg": "./src/assets/images/stockaudios/Recuerdos Mios.jpg",
	"./Relaxed Fit.jpg": "./src/assets/images/stockaudios/Relaxed Fit.jpg",
	"./Remember Me.jpg": "./src/assets/images/stockaudios/Remember Me.jpg",
	"./Retribution.jpg": "./src/assets/images/stockaudios/Retribution.jpg",
	"./Revelations.jpg": "./src/assets/images/stockaudios/Revelations.jpg",
	"./Rhythm in You.jpg": "./src/assets/images/stockaudios/Rhythm in You.jpg",
	"./Right There.jpg": "./src/assets/images/stockaudios/Right There.jpg",
	"./Rise Above.jpg": "./src/assets/images/stockaudios/Rise Above.jpg",
	"./Rise and Shout.jpg": "./src/assets/images/stockaudios/Rise and Shout.jpg",
	"./Rivers.jpg": "./src/assets/images/stockaudios/Rivers.jpg",
	"./Roaming Free.jpg": "./src/assets/images/stockaudios/Roaming Free.jpg",
	"./Rock This Joint.jpg": "./src/assets/images/stockaudios/Rock This Joint.jpg",
	"./Rocky Balboa.jpg": "./src/assets/images/stockaudios/Rocky Balboa.jpg",
	"./Rolling Wadi.jpg": "./src/assets/images/stockaudios/Rolling Wadi.jpg",
	"./Rose Colored Glasses.jpg": "./src/assets/images/stockaudios/Rose Colored Glasses.jpg",
	"./Rum.jpg": "./src/assets/images/stockaudios/Rum.jpg",
	"./Runaway.jpg": "./src/assets/images/stockaudios/Runaway.jpg",
	"./Safe Travels.jpg": "./src/assets/images/stockaudios/Safe Travels.jpg",
	"./Same Side.jpg": "./src/assets/images/stockaudios/Same Side.jpg",
	"./Sat Night.jpg": "./src/assets/images/stockaudios/Sat Night.jpg",
	"./Saturn.jpg": "./src/assets/images/stockaudios/Saturn.jpg",
	"./Sea of Clouds.jpg": "./src/assets/images/stockaudios/Sea of Clouds.jpg",
	"./Secret Garden.jpg": "./src/assets/images/stockaudios/Secret Garden.jpg",
	"./See Me Fly.jpg": "./src/assets/images/stockaudios/See Me Fly.jpg",
	"./Seine River.jpg": "./src/assets/images/stockaudios/Seine River.jpg",
	"./Settle Down.jpg": "./src/assets/images/stockaudios/Settle Down.jpg",
	"./Seven Wonders.jpg": "./src/assets/images/stockaudios/Seven Wonders.jpg",
	"./Shame on Me (ft Ashley DuBose).jpg": "./src/assets/images/stockaudios/Shame on Me (ft Ashley DuBose).jpg",
	"./Shepherd.jpg": "./src/assets/images/stockaudios/Shepherd.jpg",
	"./Shock O Banana Cover Art.jpg": "./src/assets/images/stockaudios/Shock O Banana Cover Art.jpg",
	"./Shooting Stars.jpg": "./src/assets/images/stockaudios/Shooting Stars.jpg",
	"./Side Road - Instrumental Version.jpg": "./src/assets/images/stockaudios/Side Road - Instrumental Version.jpg",
	"./Side Road.jpg": "./src/assets/images/stockaudios/Side Road.jpg",
	"./Sidewalk Strut.jpg": "./src/assets/images/stockaudios/Sidewalk Strut.jpg",
	"./Sight.jpg": "./src/assets/images/stockaudios/Sight.jpg",
	"./Silhouettes.jpg": "./src/assets/images/stockaudios/Silhouettes.jpg",
	"./Skipping.jpg": "./src/assets/images/stockaudios/Skipping.jpg",
	"./Sleep Tight.jpg": "./src/assets/images/stockaudios/Sleep Tight.jpg",
	"./Smoothie Moody.jpg": "./src/assets/images/stockaudios/Smoothie Moody.jpg",
	"./Sneaky Line.jpg": "./src/assets/images/stockaudios/Sneaky Line.jpg",
	"./Snowflakes in the Sun.jpg": "./src/assets/images/stockaudios/Snowflakes in the Sun.jpg",
	"./So Many Issues.jpg": "./src/assets/images/stockaudios/So Many Issues.jpg",
	"./Sol Dance.jpg": "./src/assets/images/stockaudios/Sol Dance.jpg",
	"./Soleil.jpg": "./src/assets/images/stockaudios/Soleil.jpg",
	"./Solis.jpg": "./src/assets/images/stockaudios/Solis.jpg",
	"./Song of the Butterflies - Strings Version.jpg": "./src/assets/images/stockaudios/Song of the Butterflies - Strings Version.jpg",
	"./Spacey Curry.jpg": "./src/assets/images/stockaudios/Spacey Curry.jpg",
	"./Spain - Instrumental Version.jpg": "./src/assets/images/stockaudios/Spain - Instrumental Version.jpg",
	"./Spiky Chin.jpg": "./src/assets/images/stockaudios/Spiky Chin.jpg",
	"./Spongy Hammer.jpg": "./src/assets/images/stockaudios/Spongy Hammer.jpg",
	"./Stairs.jpg": "./src/assets/images/stockaudios/Stairs.jpg",
	"./Standing on the Shoulders of Giants.jpg": "./src/assets/images/stockaudios/Standing on the Shoulders of Giants.jpg",
	"./Star of Wonder (Gloria) (ft Dear Gravity).jpg": "./src/assets/images/stockaudios/Star of Wonder (Gloria) (ft Dear Gravity).jpg",
	"./Staring.jpg": "./src/assets/images/stockaudios/Staring.jpg",
	"./Starry-Eyed.jpg": "./src/assets/images/stockaudios/Starry-Eyed.jpg",
	"./Start Me Up.jpg": "./src/assets/images/stockaudios/Start Me Up.jpg",
	"./Start Over.jpg": "./src/assets/images/stockaudios/Start Over.jpg",
	"./Stay Right There.jpg": "./src/assets/images/stockaudios/Stay Right There.jpg",
	"./Stay.jpg": "./src/assets/images/stockaudios/Stay.jpg",
	"./Still On.jpg": "./src/assets/images/stockaudios/Still On.jpg",
	"./Still Running.jpg": "./src/assets/images/stockaudios/Still Running.jpg",
	"./Stranger Ways.jpg": "./src/assets/images/stockaudios/Stranger Ways.jpg",
	"./Streets.jpg": "./src/assets/images/stockaudios/Streets.jpg",
	"./Subjection.jpg": "./src/assets/images/stockaudios/Subjection.jpg",
	"./Sugar - Instrumental Version.jpg": "./src/assets/images/stockaudios/Sugar - Instrumental Version.jpg",
	"./Sulla Panchina.jpg": "./src/assets/images/stockaudios/Sulla Panchina.jpg",
	"./Summer Again.jpg": "./src/assets/images/stockaudios/Summer Again.jpg",
	"./Summer Folk.jpg": "./src/assets/images/stockaudios/Summer Folk.jpg",
	"./Summer Night.jpg": "./src/assets/images/stockaudios/Summer Night.jpg",
	"./Summer Snow.jpg": "./src/assets/images/stockaudios/Summer Snow.jpg",
	"./Summertime Blues (ft Michael Shynes).jpg": "./src/assets/images/stockaudios/Summertime Blues (ft Michael Shynes).jpg",
	"./Summit.jpg": "./src/assets/images/stockaudios/Summit.jpg",
	"./Sunlapse.jpg": "./src/assets/images/stockaudios/Sunlapse.jpg",
	"./Sunny Days.jpg": "./src/assets/images/stockaudios/Sunny Days.jpg",
	"./Sunrise on the Old Celtic Port.jpg": "./src/assets/images/stockaudios/Sunrise on the Old Celtic Port.jpg",
	"./Sunrise.jpg": "./src/assets/images/stockaudios/Sunrise.jpg",
	"./Sunset Beach Song.jpg": "./src/assets/images/stockaudios/Sunset Beach Song.jpg",
	"./Surfing Time.jpg": "./src/assets/images/stockaudios/Surfing Time.jpg",
	"./Sweat It Out.jpg": "./src/assets/images/stockaudios/Sweat It Out.jpg",
	"./Sweet Georgia.jpg": "./src/assets/images/stockaudios/Sweet Georgia.jpg",
	"./Sweet Glimpse.jpg": "./src/assets/images/stockaudios/Sweet Glimpse.jpg",
	"./Take It to the Top - Instrumental Version.jpg": "./src/assets/images/stockaudios/Take It to the Top - Instrumental Version.jpg",
	"./Take It to the Top.jpg": "./src/assets/images/stockaudios/Take It to the Top.jpg",
	"./Take Me On Down - Instrumental Version.jpg": "./src/assets/images/stockaudios/Take Me On Down - Instrumental Version.jpg",
	"./Take Off.jpg": "./src/assets/images/stockaudios/Take Off.jpg",
	"./Take You Anyway.jpg": "./src/assets/images/stockaudios/Take You Anyway.jpg",
	"./Taking Some Inspiration.jpg": "./src/assets/images/stockaudios/Taking Some Inspiration.jpg",
	"./Tangled Cover Art.jpg": "./src/assets/images/stockaudios/Tangled Cover Art.jpg",
	"./Taurus.jpg": "./src/assets/images/stockaudios/Taurus.jpg",
	"./Tech Knowledge.jpg": "./src/assets/images/stockaudios/Tech Knowledge.jpg",
	"./Tech No Ledge.jpg": "./src/assets/images/stockaudios/Tech No Ledge.jpg",
	"./Teenage Dream.jpg": "./src/assets/images/stockaudios/Teenage Dream.jpg",
	"./Tell Me.jpg": "./src/assets/images/stockaudios/Tell Me.jpg",
	"./Tell You.jpg": "./src/assets/images/stockaudios/Tell You.jpg",
	"./Temptation.jpg": "./src/assets/images/stockaudios/Temptation.jpg",
	"./Tempted.jpg": "./src/assets/images/stockaudios/Tempted.jpg",
	"./Tepal.jpg": "./src/assets/images/stockaudios/Tepal.jpg",
	"./The Arrival.jpg": "./src/assets/images/stockaudios/The Arrival.jpg",
	"./The Ballad of Orpheus.jpg": "./src/assets/images/stockaudios/The Ballad of Orpheus.jpg",
	"./The Bold and Brave.jpg": "./src/assets/images/stockaudios/The Bold and Brave.jpg",
	"./The Creator of My Heart.jpg": "./src/assets/images/stockaudios/The Creator of My Heart.jpg",
	"./The End.jpg": "./src/assets/images/stockaudios/The End.jpg",
	"./The Final Performance.jpg": "./src/assets/images/stockaudios/The Final Performance.jpg",
	"./The French Connection.jpg": "./src/assets/images/stockaudios/The French Connection.jpg",
	"./The Future Is Now.jpg": "./src/assets/images/stockaudios/The Future Is Now.jpg",
	"./The Great Escape.jpg": "./src/assets/images/stockaudios/The Great Escape.jpg",
	"./The Isle of Skye.jpg": "./src/assets/images/stockaudios/The Isle of Skye.jpg",
	"./The Nest - Instrumental Version.jpg": "./src/assets/images/stockaudios/The Nest - Instrumental Version.jpg",
	"./The People.jpg": "./src/assets/images/stockaudios/The People.jpg",
	"./The Promise.jpg": "./src/assets/images/stockaudios/The Promise.jpg",
	"./The Racer - Piano Version.jpg": "./src/assets/images/stockaudios/The Racer - Piano Version.jpg",
	"./The Racer.jpg": "./src/assets/images/stockaudios/The Racer.jpg",
	"./The Vast Unfolding.jpg": "./src/assets/images/stockaudios/The Vast Unfolding.jpg",
	"./The Wedding Song.jpg": "./src/assets/images/stockaudios/The Wedding Song.jpg",
	"./The Wild West.jpg": "./src/assets/images/stockaudios/The Wild West.jpg",
	"./The World Inside.jpg": "./src/assets/images/stockaudios/The World Inside.jpg",
	"./Then I Came.jpg": "./src/assets/images/stockaudios/Then I Came.jpg",
	"./Things We Wouldn't Say.jpg": "./src/assets/images/stockaudios/Things We Wouldn't Say.jpg",
	"./This Time Coming Soon.jpg": "./src/assets/images/stockaudios/This Time Coming Soon.jpg",
	"./Those Were the Days.jpg": "./src/assets/images/stockaudios/Those Were the Days.jpg",
	"./Thoughts in Motion - Alternative Version.jpg": "./src/assets/images/stockaudios/Thoughts in Motion - Alternative Version.jpg",
	"./Thoughts in Motion - No Backing Vocals.jpg": "./src/assets/images/stockaudios/Thoughts in Motion - No Backing Vocals.jpg",
	"./Three Weeks to Go.jpg": "./src/assets/images/stockaudios/Three Weeks to Go.jpg",
	"./Through the Fire - Instrumental Version.jpg": "./src/assets/images/stockaudios/Through the Fire - Instrumental Version.jpg",
	"./Through the Fire.jpg": "./src/assets/images/stockaudios/Through the Fire.jpg",
	"./Through the Sunset.jpg": "./src/assets/images/stockaudios/Through the Sunset.jpg",
	"./Tiding.jpg": "./src/assets/images/stockaudios/Tiding.jpg",
	"./Time Stood Still - Instrumental Version.jpg": "./src/assets/images/stockaudios/Time Stood Still - Instrumental Version.jpg",
	"./Time to Mix Blue and Red and Make a Mauve.jpg": "./src/assets/images/stockaudios/Time to Mix Blue and Red and Make a Mauve.jpg",
	"./Time to Move.jpg": "./src/assets/images/stockaudios/Time to Move.jpg",
	"./Timebide.jpg": "./src/assets/images/stockaudios/Timebide.jpg",
	"./Timeless.jpg": "./src/assets/images/stockaudios/Timeless.jpg",
	"./Timing.jpg": "./src/assets/images/stockaudios/Timing.jpg",
	"./To the Sky.jpg": "./src/assets/images/stockaudios/To the Sky.jpg",
	"./Tomb.jpg": "./src/assets/images/stockaudios/Tomb.jpg",
	"./Tombi.jpg": "./src/assets/images/stockaudios/Tombi.jpg",
	"./Tornado.jpg": "./src/assets/images/stockaudios/Tornado.jpg",
	"./Toy Symphony.jpg": "./src/assets/images/stockaudios/Toy Symphony.jpg",
	"./Treeline.jpg": "./src/assets/images/stockaudios/Treeline.jpg",
	"./Tropical Paradise.jpg": "./src/assets/images/stockaudios/Tropical Paradise.jpg",
	"./Truth Is - ft Wvllvce.jpg": "./src/assets/images/stockaudios/Truth Is - ft Wvllvce.jpg",
	"./Tulip.jpg": "./src/assets/images/stockaudios/Tulip.jpg",
	"./Tuning.jpg": "./src/assets/images/stockaudios/Tuning.jpg",
	"./Turn It Up (Rewind Selecta).jpg": "./src/assets/images/stockaudios/Turn It Up (Rewind Selecta).jpg",
	"./Typical.jpg": "./src/assets/images/stockaudios/Typical.jpg",
	"./Ultra Light.jpg": "./src/assets/images/stockaudios/Ultra Light.jpg",
	"./Under a Blanket.jpg": "./src/assets/images/stockaudios/Under a Blanket.jpg",
	"./Upgrading Alone.jpg": "./src/assets/images/stockaudios/Upgrading Alone.jpg",
	"./Use in Wondering.jpg": "./src/assets/images/stockaudios/Use in Wondering.jpg",
	"./Verve - Short Version.jpg": "./src/assets/images/stockaudios/Verve - Short Version.jpg",
	"./Verve.jpg": "./src/assets/images/stockaudios/Verve.jpg",
	"./Voices.jpg": "./src/assets/images/stockaudios/Voices.jpg",
	"./Volga.jpg": "./src/assets/images/stockaudios/Volga.jpg",
	"./Vuelta al Sol.jpg": "./src/assets/images/stockaudios/Vuelta al Sol.jpg",
	"./Waiting for the Storm to Break.jpg": "./src/assets/images/stockaudios/Waiting for the Storm to Break.jpg",
	"./Walkman Snail Shoes.jpg": "./src/assets/images/stockaudios/Walkman Snail Shoes.jpg",
	"./Wannabe - Instrumental Version.jpg": "./src/assets/images/stockaudios/Wannabe - Instrumental Version.jpg",
	"./Watch Out - Instrumental Version.jpg": "./src/assets/images/stockaudios/Watch Out - Instrumental Version.jpg",
	"./Waters Crashing.jpg": "./src/assets/images/stockaudios/Waters Crashing.jpg",
	"./Wave of Emotions.jpg": "./src/assets/images/stockaudios/Wave of Emotions.jpg",
	"./We Are Echoes.jpg": "./src/assets/images/stockaudios/We Are Echoes.jpg",
	"./We Got Love.jpg": "./src/assets/images/stockaudios/We Got Love.jpg",
	"./We Shall Overcome.jpg": "./src/assets/images/stockaudios/We Shall Overcome.jpg",
	"./We Together.jpg": "./src/assets/images/stockaudios/We Together.jpg",
	"./We Will Get There - Short Version B.jpg": "./src/assets/images/stockaudios/We Will Get There - Short Version B.jpg",
	"./We Won't Survive.jpg": "./src/assets/images/stockaudios/We Won't Survive.jpg",
	"./We.jpg": "./src/assets/images/stockaudios/We.jpg",
	"./Wedding Song.jpg": "./src/assets/images/stockaudios/Wedding Song.jpg",
	"./When I Get There.jpg": "./src/assets/images/stockaudios/When I Get There.jpg",
	"./When Stars Align.jpg": "./src/assets/images/stockaudios/When Stars Align.jpg",
	"./While She Smiled.jpg": "./src/assets/images/stockaudios/While She Smiled.jpg",
	"./Whisper Repeating.jpg": "./src/assets/images/stockaudios/Whisper Repeating.jpg",
	"./Wingsuit Flying.jpg": "./src/assets/images/stockaudios/Wingsuit Flying.jpg",
	"./Winner.jpg": "./src/assets/images/stockaudios/Winner.jpg",
	"./Winoa.jpg": "./src/assets/images/stockaudios/Winoa.jpg",
	"./Winter.jpg": "./src/assets/images/stockaudios/Winter.jpg",
	"./With You.jpg": "./src/assets/images/stockaudios/With You.jpg",
	"./Xerces.jpg": "./src/assets/images/stockaudios/Xerces.jpg",
	"./Yes Man.jpg": "./src/assets/images/stockaudios/Yes Man.jpg",
	"./You and Me.jpg": "./src/assets/images/stockaudios/You and Me.jpg",
	"./You and the Summer - Instrumental Version.jpg": "./src/assets/images/stockaudios/You and the Summer - Instrumental Version.jpg",
	"./Young Summer.jpg": "./src/assets/images/stockaudios/Young Summer.jpg",
	"./Your Captain.jpg": "./src/assets/images/stockaudios/Your Captain.jpg",
	"./sam10.png": "./src/assets/images/stockaudios/sam10.png",
	"./sam11.png": "./src/assets/images/stockaudios/sam11.png",
	"./sam2.jpg": "./src/assets/images/stockaudios/sam2.jpg",
	"./sam3.jpg": "./src/assets/images/stockaudios/sam3.jpg",
	"./sam6.png": "./src/assets/images/stockaudios/sam6.png",
	"./sam7.png": "./src/assets/images/stockaudios/sam7.png",
	"./sam8.png": "./src/assets/images/stockaudios/sam8.png",
	"./sam9.png": "./src/assets/images/stockaudios/sam9.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/stockaudios sync recursive ^\\.\\/.*$";